let adapter = null;
/** Call once from the app entrypoint, before the first request or render. */
export function configurePlatform(next) {
    adapter = next;
}
/**
 * Read at call time, never at module time.
 *
 * Throws rather than falling back to a browser default: a silent fallback would
 * turn "the native app forgot to configure itself" into a `sessionStorage is not
 * defined` thrown from inside a dependency, which is a much worse afternoon.
 */
export function platform() {
    if (adapter === null) {
        throw new Error('configurePlatform() must be called before @fieldvision/core is used. ' +
            'Web apps get this from importing @fieldvision/web-core; the Expo app ' +
            'calls it in app/_layout.tsx.');
    }
    return adapter;
}
//# sourceMappingURL=platform.js.map